
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/astrology-and-theurgy",
      function () {
        return require("private-next-pages/astrology-and-theurgy/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/astrology-and-theurgy"])
      });
    }
  